import React from 'react'
import ContactForm from './ContactForm'
import { ContactWrapper } from './Styled'
import { Col, Container, Row } from 'react-bootstrap'
import { TextButton, TextWithIcon } from '../../../ui/CustomElements'
import { Box, MainHeading, SpanStyled, SubHeadingStyled, TextStyled, } from '../../../ui/Elements'
import { ContactEmail, ContactInstagram, ContactLinkedin, ContactPhone, ContactX, Instagram, LinkedIn, SnapChat, Tiktok, Twitter } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
// import Footer from '../../footer/Footer'
import i18n from '../../../Languages/INEXT'
const Contact = () => {
	const WhatsApp = () => {
        const phoneNumber = '+966506184384';
        const message = 'Hello, this is Tamkeen';
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };
	const Map = ""
	const { t } = useTranslation();
	const socialIcon = [
			
		{
			img: <Twitter />,
			link: 'https://x.com/tamkeenxpo',
		},
		{
			img: <Instagram />,
			link: 'https://www.instagram.com/tamkeenxpo/',
		},
		/* {
			img: <Tiktok />,
			link: 'https://www.tiktok.com/',
		},
		{
			img: <SnapChat />,
			link: 'https://snapchat.com/',
		}, */
		/* {
			img: <LinkedIn />,
			link: 'https://www.linkedin.com/',
		}, */
	]
	return (
		<>
			<ContactWrapper id='contact' className='contact-bg container-fluid'>

				<Container>
					<Box className='containerContact'>
						<Row>
							<Col md={12} className='contact-Us-detail'>
								<Box className='contactHeadings'>
									<MainHeading className='main-heading main-heading-sub' size="32px" color="var(--secondaryColor)">
										{t('ContacHeading')}
									</MainHeading>
									
								</Box>
							</Col>
							<Col lg={6} md={12} className='contact-Us-detail'>
								<Box className='contect-with-us'>
									
									<ContactForm />
								</Box>
							</Col>
							<Col lg={6} md={12} className='contact-Us'>
								<Box className='contactDetailCol'>
									<Box className='contactComBox'>
										<Box className='contactComHeading'>
											{t('Address')}
										</Box>
										<SpanStyled className='d-flex addrTxt' family="var(--medium)" color='var(--bg2)'>
											{i18n.language === "ar" ? 
												<>
													<span>{t('AddressTxt')}&nbsp;</span><span className='engReg'>{t('AddressTxt1')}&nbsp;</span><span>{t('AddressTxt2')}</span>
														{/* &nbsp;</span><span className='engReg'>{t('AddressTxt3')}&nbsp;</span><span>{t('AddressTxt4')}</span> */}
												</>
											: 
												<>
													{t('AddressTxt')}
												</>
											}
											
										</SpanStyled>
									</Box>
									<Box className='contactComBox'>
										<Box className='contactComHeading'>
											{t('Contact')}
										</Box>
										<Box className='contact-info'>
											<TextButton clName="dgts engReg wtpBtnCon" icon={ContactPhone} label='+966 50 618 4384' onClick={WhatsApp} color="var(--black)" />
											<TextWithIcon icon={ContactEmail} title='info@tamkeen.sa' href="mailto:info@tamkeen.sa" color="var(--black)" />
										</Box>
									</Box>
									<Box className='contactComBox no-border'>
										<Box className='contactComHeading'>
											{t('StayConnected')}
										</Box>
										<Box className='Social-links'>
											{
												socialIcon.map((list, key) => (
													<a href={list.link} target="_blank" key={key} className='contact-links'>
														{list.img}
													</a>
												))
											}
										</Box>
									</Box>

									
								</Box>
								
								
								
							</Col>
							
						</Row>
					</Box>
				</Container>

			</ContactWrapper>
		</>
	)
}

export default Contact